import {t} from "@lingui/core/macro";

export function validateClassCode(classCode: string): string | null {
    if (!/^[a-zA-Z0-9]*$/i.test(classCode)) {
        return t`Oops! That isn't a valid class code. Double check the code, or ask your teacher for help.`;
    }

    return null;
}
